export const LEFT_SPACE_CODE = "leftSpaceCode";
export const LEFT_CODE = "leftCode";
export const RIGHT_CODE = "rightCode";
export const RIGHT_SPACE_CODE = "rightSpaceCode";
